import type {ReactElement} from 'react';
import React, {useState} from 'react';
import {GridMediaItem} from '../grid-media-item';
import styles from './grid-icon-item.module.scss';
import type {GridIconItemProps} from '@Components/base-grid/components/grid-icon-item/grid-icon-item.types';

export function GridIconItem({...props}: GridIconItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <img
          onLoad={(): void => {
            setIsImageLoaded(true);
          }}
          src={props.thumbSrc}
          className={styles.thumb}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
